import { useEffect } from "react";

import { QICK_APP_URL } from "@/lib/routes";

const Dashboard = () => {
    useEffect(() => {
        window.location.replace(QICK_APP_URL);
    }, []);

    return (
        <main className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 text-slate-700">
            <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-sm font-semibold shadow-sm">
                Je wordt doorgestuurd naar QICK!...
            </div>
        </main>
    );
};

export default Dashboard;
